import { gql } from 'urql';

export const Q_CLIENTES = gql`
  query Clientes($page: Int, $pageSize: Int, $filter: ClienteFilter, $sort: ClienteSort) {
    clientes(page: $page, pageSize: $pageSize, filter: $filter, sort: $sort) {
      totalCount
      page
      pageSize
      edges {
        node {
          id
          razonSocial
          nombreFantasia
          codigo
          cuit
          condicionIVA
          emails
          telefono
          celular
          direccion
          pisoDepto
          provinciaId
          localidadId
          saldoPendiente
          ultimoMovimiento
          sucursalResponsableId
          sucursalResponsableNombre
          activo
          # Relaciones de dirección
          provincia {
            id
            nombre
            codigo
          }
          localidad {
            id
            nombre
            codigoLocalidad
            provinciaId
          }
          # Información de Notificaciones
          tieneNotificaciones
          canalesNotificacion
          # Información de Tarifas
          tarifa {
            listaTarifaCodigo
            listaTarifaNombre
            descuentoPorcentaje
            prioridadDespacho
            prioridadEntrega
          }
        }
      }
    }
  }
`;

export const Q_SUCURSALES_CLIENTES = gql`
  query SucursalesClientes { sucursales { id nombre } }
`;

export const Q_CLIENTE = gql`
  query Cliente($id: ID!) {
    cliente(id: $id) {
      id
      razonSocial
      nombreFantasia
      tipoDocumento
      cuit
      condicionIVA
      categoriaCliente
      codigo
      tipoCliente
      estado
      motivoEstado
      cp
      lat
      lng
      emails
      telefono
      celular
      direccion
      provinciaId
      localidadId
      codigoPostal
      observaciones
      activo
      # Relaciones de dirección
      provincia {
        id
        nombre
        codigo
      }
      localidad {
        id
        nombre
        codigoLocalidad
        provinciaId
      }
      # Campos comerciales
      empresa
      sucursal
      vendedor
      tipoCliente
      listaPrecio
      condicionVenta
      condicionPago
      plazoPago
      metodoPago
      limiteCredito
      diasVencimiento
      toleranciaVencidos
      prioridadOperativa
      bloqueoPorDeuda
      umbralDeuda
      slaDespachoHs
      slaEntregaHs
      zonaReparto
      observacionesComerciales
      fechaAlta
      contactos {
        id
        nombre
        rolSector
        email
        telefono
        celular
        principal
        operaciones
        cobranzas
        canalPreferido
        horarioDesde
        horarioHasta
        activo
      }
      domicilios {
        id
        alias
        tipo
        direccion
        cp
        provinciaId
        localidadId
        contacto
        horario
        observacionesAcceso
        lat
        lng
        esDefault
        activo
      }
      notificacionesConfig {
        destinosGenerales
        eventosConfig
        noEnviarFueraHorario
        horarioDesde
        horarioHasta
        activo
      }
      tarifasConfig {
        tarifaBaseId
        descuentoPct
        recargoPct
        requiereConfirmacion
        prioridadDespacho
        prioridadEntrega
        observaciones
        activo
      }
    }
  }
`;

export const Q_CLIENTE_SUBCUENTAS_ACTIVAS = gql`
  query ClienteSubcuentasActivas($clienteId: ID!) {
    subcuentasCliente(clienteId: $clienteId, incluirInactivas: false) {
      id
      codigo
      nombre
      activo
      sucursalResponsableId
    }
  }
`;

export const M_CREATE_CLIENTE_COMPLETO = gql`
  mutation CreateClienteCompleto($input: ClienteCompletoInput!) {
    createClienteCompleto(input: $input) {
      id
      razonSocial
      activo
    }
  }
`;

export const M_UPDATE_CLIENTE_COMPLETO = gql`
  mutation UpdateClienteCompleto($id: ID!, $input: ClienteCompletoInput!) {
    updateClienteCompleto(id: $id, input: $input) {
      id
      razonSocial
      activo
    }
  }
`;

export const M_DELETE_CLIENTE = gql`
  mutation DeleteCliente($id: ID!) {
    deleteCliente(id: $id)
  }
`;

export const M_CREATE_CLIENTE_SUBCUENTA = gql`
  mutation CreateClienteSubcuenta($clienteId: ID!, $input: ClienteSubcuentaInput!) {
    createClienteSubcuenta(clienteId: $clienteId, input: $input) {
      id codigo nombre activo observaciones
    }
  }
`;

export const M_UPDATE_CLIENTE_SUBCUENTA = gql`
  mutation UpdateClienteSubcuenta($clienteId: ID!, $id: ID!, $input: ClienteSubcuentaInput!) {
    updateClienteSubcuenta(clienteId: $clienteId, id: $id, input: $input) {
      id codigo nombre activo observaciones
    }
  }
`;

export const M_DELETE_CLIENTE_SUBCUENTA = gql`
  mutation DeleteClienteSubcuenta($clienteId: ID!, $id: ID!) {
    deleteClienteSubcuenta(clienteId: $clienteId, id: $id)
  }
`;
